import { forwardRef } from 'react';
import { motion } from 'framer-motion';
import './Card.scss';

const Card = forwardRef(
  (
    {
      children,
      padding = 'md',
      animate = false,
      isActive = false,
      className = '',
      onClick,
      ...props
    },
    ref
  ) => {
    const classes = `card glass-card card-padding-${padding} ${
      isActive ? 'active' : ''
    } ${className} d-flex flex-column`.trim();

    if (animate) {
      return (
        <motion.div
          ref={ref}
          className={classes}
          onClick={onClick}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          whileHover={{ y: -5 }}
          {...props}
        >
          {children}
        </motion.div>
      );
    }

    return (
      <div ref={ref} className={classes} onClick={onClick} {...props}>
        {children}
      </div>
    );
  }
);

// Card sub-components
const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`card-header ${className}`} {...props}>
    {children}
  </div>
);

const CardBody = ({ children, className = '', ...props }) => (
  <div className={`card-body ${className}`} {...props}>
    {children}
  </div>
);

const CardFooter = ({ children, className = '', ...props }) => (
  <div className={`card-footer ${className} mt-auto`} {...props}>
    {children}
  </div>
);

Card.displayName = 'Card';
Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
